import * as React from 'react';
import { Helmet } from 'react-helmet';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { Toaster } from 'bundles/enterprise-ui/components';
import SecureInternalTool from 'bundles/internal-common/components/SecureInternalTool';

import 'css!bundles/internal-enterprise/styl/index';

class EnterpriseApp extends React.LegacyComponentWithChildren<{
  requestCountryCode: string;
  csrfToken: string;
}> {
  static contextTypes = {
    getStore: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof EnterpriseApp.contextTypes>;

  static childContextTypes = {
    csrfToken: PropTypes.string,
    requestCountryCode: PropTypes.string,
  };

  getChildContext() {
    return {
      csrfToken: this.props.csrfToken,
      requestCountryCode: this.props.requestCountryCode,
    };
  }

  static menuItems = [
    {
      name: 'Find Enterprise User',
      route: '/internal/enterprise',
    },
    {
      name: 'Email Trigger',
      route: '/internal/enterprise/trigger/program',
    },
    {
      name: 'Organizations',
      route: '/internal/enterprise/organizations',
    },
    {
      name: 'Program Invitation',
      route: '/internal/enterprise/invitation',
    },
    {
      name: 'Administrator Lookup',
      route: '/internal/enterprise/program-lookup',
    },
    {
      name: 'Curriculum Download',
      route: '/internal/enterprise/program-download',
    },
    {
      name: 'Curriculum Upload',
      route: '/internal/enterprise/program-bulk-add',
    },
    {
      name: 'Curriculum Builder',
      route: '/internal/enterprise/curriculum-builder',
    },
    {
      name: 'Enterprise Lead',
      route: '/internal/enterprise/lead',
    },
  ];

  helmetMeta = {
    title: 'Enterprise Tools',
  };

  render() {
    return (
      <div className="rc-EnterpriseApp">
        <Helmet {...this.helmetMeta} />
        <Toaster>
          <SecureInternalTool name="Enterprise Tool" menuItems={EnterpriseApp.menuItems}>
            {this.props.children}
          </SecureInternalTool>
        </Toaster>
      </div>
    );
  }
}

export default connectToStores(EnterpriseApp, ['ApplicationStore'], (context, props) => ({
  ...props,
  csrfToken: context.ApplicationStore.getState().csrfToken,
  requestCountryCode: context.ApplicationStore.getState().requestCountryCode,
}));
